import { render, staticRenderFns } from "./RatingFood.vue?vue&type=template&id=f09727ec&scoped=true&"
import script from "./RatingFood.vue?vue&type=script&lang=js&"
export * from "./RatingFood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09727ec",
  null
  
)

export default component.exports